var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#262626",
    viewBox: "0 0 21 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.288 3.032a1.63 1.63 0 0 0 2.424 0l.788-.865a1.633 1.633 0 0 1 2.842 1.177l-.06 1.167a1.632 1.632 0 0 0 1.71 1.711l1.166-.059a1.632 1.632 0 0 1 1.175 2.842l-.868.783a1.634 1.634 0 0 0 0 2.425l.868.783a1.632 1.632 0 0 1-1.177 2.841l-1.167-.059a1.632 1.632 0 0 0-1.713 1.714l.06 1.166a1.633 1.633 0 0 1-2.836 1.175l-.784-.867a1.633 1.633 0 0 0-2.423 0l-.788.867a1.633 1.633 0 0 1-2.838-1.173l.06-1.167a1.632 1.632 0 0 0-1.714-1.713l-1.166.06A1.632 1.632 0 0 1 1.667 13l.867-.783a1.633 1.633 0 0 0 0-2.425l-.867-.787A1.632 1.632 0 0 1 2.84 6.167l1.167.059a1.632 1.632 0 0 0 1.715-1.717l-.056-1.167a1.632 1.632 0 0 1 2.838-1.175l.783.865Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    className: "highlight",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon_settings.314fecf47a98d2dd58ccd98905fc7d89.svg";
export { ForwardRef as ReactComponent };